import { render } from "./ProListSurveys.vue?vue&type=template&id=20069c24"
import script from "./ProListSurveys.vue?vue&type=script&lang=js"
export * from "./ProListSurveys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__